import React from 'react';
import IVFPoints from './IVFPoints';
import {
  BannerAbsoluteSection,
  BannerSection,
  BlueColor,
  BlueSection,
  FreeConsultant,
  IVFCenterTopSec,
  TopBanner,
} from './styled';
import AppointmentForm from '../../IVFCenters/AppointmentForm';
import FormComponent from '../../../Common/FormComponent/formComponent';

export default function index(props) {
  const {
    inputActive,
    selectedCity,
    bannerImage,
    element,
    isGeneralItem,
    index,
  } = props;
  return (
    <IVFCenterTopSec index={index}>
      {/* <TopBanner src="/images/ivfcentertopbanner.png" alt="" /> */}
      {bannerImage ? (
        <TopBanner
          src={bannerImage}
          srcSet={`${bannerImage}?tr=w-360,q-80 2w, ${bannerImage}?tr=w-2000,q-80 608w`}
          sizes="(max-width: 720px) 2px,608px"
          fetchpriority="high"
          alt=""
          isGeneralItem={isGeneralItem}
        />
      ) : null}

      <BannerAbsoluteSection>
        <BannerSection>
          <div className="leftSection">
            <BlueSection isGeneralItem={isGeneralItem} index={index}>
              <BlueColor>
                <FreeConsultant bold>
                  {isGeneralItem
                    ? element?.heading
                    : 'Get Free IVF Consultation From Top Fertility Clinics'}
                </FreeConsultant>
              </BlueColor>
            </BlueSection>
            <IVFPoints formPoints={element?.formPoints} />
          </div>
          <div className="rightSection">
            {isGeneralItem ? (
              <FormComponent
                data={element?.formFields}
                ctaButtonText={element?.ctaText}
                skuId={379}
                skuName={'Get Free Consultation on IVF'}
                formSuccessData={element?.formSuccessData}
                key={index}
              />
            ) : (
              <AppointmentForm
                showFullForm={false}
                inputActive={inputActive}
                desktopform={true}
                selectedCity={selectedCity}
              />
            )}
          </div>
        </BannerSection>
      </BannerAbsoluteSection>
    </IVFCenterTopSec>
  );
}
